var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from "lodash/get";
import BuilderError from '../BuilderError';
import componentMap from '../map';
import builder from "../builder";
import { generateComponentKey } from '../utils';
export function render(node, path) {
    var Content = node.Content, Children = node.Children;
    if (!Content)
        return null;
    var componentName = Content.componentName, type = Content.type;
    var componentKey = get(Content, 'props.componentKey', get(Content, 'componentKey', generateComponentKey(path, type !== null && type !== void 0 ? type : componentName)));
    // Component type not available
    if (!componentMap[Content.type]) {
        throw new BuilderError("Component of type ".concat(type || 'undefined', " not found for the position ").concat(componentName !== null && componentName !== void 0 ? componentName : componentKey));
    }
    var spots = null;
    var NewComponent = componentMap[type];
    if (!Children) {
        return (_jsx(NewComponent, __assign({ componentKey: componentKey }, Content.props, { componentTitle: Content.label, product: node.Product })));
    }
    if (Children)
        spots = builder(path, Children, null, null, path);
    /**
     * Example: spots.child1 has to slot into spot1
     * solution:
     *  each "located" child receives Content, Children, spot: ... and then will be rendered at that location
     */
    return (_jsx(NewComponent, __assign({}, Content.props, { componentKey: componentKey, spots: spots, componentTitle: Content.label, product: node.Product })));
}
